import "./notificationbell.css";
import { Icon, Badge, Modal, notification } from "antd";
import React, { Component } from "react";
import axios from "axios";
import NotificationScroll from "./notificationScroll";
import $ from "jquery";
import io from "socket.io-client";
import { SERVER_URL } from "../utils/Constants";
import { useSocketStore } from "../store/slices/NotificationSlice/notification_slice";
import { useBoundStore } from "../store/useBoundStore";



$(document).mouseup(function (e) {
  // var container = $("#myDropdown");
  // if the target of the click isn't the container nor a descendant of the container
  if (
    $(e.target)
      .parents("button")
      .attr("class") !== "dropdownbtn" &&
    $(e.target).parent()[0].className !== "anticon anticon-delete" &&
    $(e.target).parent()[0].className !==
    "dropdown-content notification_dropdown" &&
    $(e.target).parent()[0].className !== "ant-col ant-col-md-20" &&
    $(e.target).parent()[0].className
  ) {
    if ($(".dropdown-content").length > 0) {
      $(".dropdownbtn").trigger("click");
    }
  }
});




export class NotificationBell extends Component {
  _isMounted = false; // Track component mount status

  state = {
    toggle: false,
    unseen_notifications: 0,
    external_rac_files_unseen: 0,
    toggleDialog: false,
    notificationId: "",
    notifications: [],
    socket: null,
    notificationVisible: false,
    lastCount: 0,
    lastMessage: "",
    side_bar_collapsed: false
  };

  componentDidMount() {

    this.unsubscribeNotificationUI = useBoundStore.subscribe((state) => {
      this.setState({
        unseen_notifications: state.notificationUI.unseen_notifications,
        external_rac_files_unseen: state.notificationUI.external_rac_files_unseen,
        side_bar_collapsed: state.notificationUI.side_bar_collapsed
      });
    });


    this._isMounted = true;
    this.webSocketConnectionAndSubscription();




    // this.fetchNotifications(); // comment as same api call twice
  }

  componentWillUnmount() {
    this._isMounted = false;

    this.unsubscribeNotificationUI && this.unsubscribeNotificationUI();

    if (this.state.socket) {
      this.state.socket.disconnect();
      //console.log("❌ Disconnected from WebSocket server");
    }
  }

  fetchNotifications = () => {
    axios
      .get("/api/get_notification")
      .then((res) => {
        if (this._isMounted) {
          const unseenCount = res.data.message.filter((not) => !not.seen).length;
          useBoundStore.getState().setNotificationSeenUnseen({
            unseen_notifications: unseenCount,
            is_notification_cross_icon_clicked: false

          });
          this.setState({ unseen_notifications: unseenCount });
        }
      })
      .catch((err) => console.error("❌ Error fetching notifications:", err));
  };


  getNotificationOnLogin = () => {
    axios
      .get("/api/get_notification")
      .then((res) => {
        if (this._isMounted) {
          const unseenCount = res.data.message.filter((not) => !not.seen).length;
          useBoundStore.getState().setNotificationSeenUnseen({
            unseen_notifications: unseenCount,
            is_notification_cross_icon_clicked: false
          });
          this.setState({ unseen_notifications: unseenCount });
          if (unseenCount > 0) {
            this.showNotificationPopup(`You have ${unseenCount} new notification${unseenCount > 1 ? "s" : ""}, please click here to view.`,
              unseenCount);
          }

        }
      })
      .catch((err) => console.error("❌ Error fetching notifications:", err));
  };

  webSocketConnectionAndSubscription = () => {
    axios
      .get("/api/user", { withCredentials: true })
      .then((res) => {
        const newSocket = io(SERVER_URL, {
          query: { userId: res.data.id },
          withCredentials: true,
          transports: ["websocket", "polling"],
          secure: false,
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 3000,
        });

        newSocket.on("connect", () => {
          console.log("Connected to WebSocket server");
          newSocket.emit("subscribe", { userId: res.data.id });
          this.getNotificationOnLogin();
          newSocket.on("subscription_success", (response) => console.log("Subscription success:", response, "sid:", newSocket.id));
        });

        newSocket.on("notification", (data) => {
          console.log("New notification received:", data);
          if (data.data.length > 0) {
            const unseen = data.data.filter((e) => !e.seen);

            this.setState((prevState) => {
              const newCount = unseen.length;
              //  prevState.unseen_notifications + 

              useBoundStore.getState().setNotificationSeenUnseen({
                unseen_notifications: newCount
                , is_notification_cross_icon_clicked: false
              });

              return { unseen_notifications: newCount };
            }, () => {
              this.showNotificationPopup(
                `You have ${this.state.unseen_notifications} new notification${this.state.unseen_notifications > 1 ? "s" : ""}, please click here to view.`,
                this.state.unseen_notifications
              );
            });
          }
        });

        this.setState({ socket: newSocket });
        useSocketStore.getState().setSocket(newSocket);

        return () => {
          if (this.state.socket) {
            this.state.socket.disconnect();
            //   console.log("❌ Disconnected from WebSocket server");
          }
        };
      })
      .catch((err) => console.error("❌ Authentication failed:", err));
  };


  // componentDidUpdate(prevProps, prevState) {
  //   const side_bar_collapsed = this.state.side_bar_collapsed;

  //   // 👇 1. When sidebar state changes → re-open popup with new style
  //   if (prevState.side_bar_collapsed !== side_bar_collapsed) {
  //     if (this.state.notificationVisible && this.state.unseen_notifications > 0) {
  //       notification.close("notification-popup");
  //       notification.destroy();
  //       if (this.state.lastCount > 0) {
  //         this.openNotification(
  //           this.state.lastMessage,
  //           this.state.lastCount
  //         );
  //       }
  //     }
  //   }

  //   //  2. Existing logic for unseen count changes
  //   if (
  //     prevState.unseen_notifications !== this.state.unseen_notifications ||
  //     prevState.external_rac_files_unseen !==
  //     this.state.external_rac_files_unseen
  //   ) {
  //     if (
  //       this.state.notificationVisible &&
  //       this.state.unseen_notifications > 0
  //     ) {
  //       notification.close("notification-popup");
  //       notification.destroy();

  //       if (this.state.lastCount > 0) {
  //         this.openNotification(
  //           this.state.lastMessage,
  //           this.state.lastCount
  //         );
  //       }
  //     }
  //   }
  // }



  componentDidUpdate(prevProps, prevState) {
    const {
      side_bar_collapsed,
      unseen_notifications,
      external_rac_files_unseen,
      notificationVisible,
    } = this.state;

    const shouldUpdateStyle =
      prevState.side_bar_collapsed !== side_bar_collapsed ||
      prevState.unseen_notifications !== unseen_notifications ||
      prevState.external_rac_files_unseen !== external_rac_files_unseen;

    if (notificationVisible && shouldUpdateStyle) {
      this.applyNotificationStyle();
    }
  }



  applyNotificationStyle = () => {
    const node = document.querySelector(".ant-notification-notice");

    if (!node) return;

    const style = this.getNotificationStyle();

    // 🔄 Reset previously applied inline styles
    node.style.position = "";
    node.style.left = "";
    node.style.right = "";
    node.style.transform = "";
    node.style.width = "";

    // ✅ Apply current computed style
    Object.entries(style).forEach(([key, value]) => {
      node.style[key] = value;
    });
  };



  getNotificationStyle = () => {
    const {
      unseen_notifications,
      external_rac_files_unseen,
      side_bar_collapsed,
    } = this.state;

    const centeredStyle = {
      position: "fixed",
      left: "50%",
      transform: "translate(-50%, 0%)",
      width: "fit-content",
    };

    const ifExtBadPNNotificationStyle = {
      position: "fixed",
      left: "50%",
      transform: "translate(-40%, 40%)",
      width: "fit-content",
    };

    const notificationStyle = {
      position: "fixed",
      left: "50%",
      transform: "translate(-50%, 40%)",
      width: "fit-content",
    };

    const hasUnseen =
      unseen_notifications > 0 && external_rac_files_unseen > 0;

    if (side_bar_collapsed) {
      return hasUnseen ? notificationStyle : centeredStyle;
    }

    return hasUnseen ? ifExtBadPNNotificationStyle : centeredStyle;
  };





  showNotificationPopup = (message, count) => {
    this.setState({
      notificationVisible: true,
      lastCount: count,
      lastMessage: message
    });
    if (count > 0) {
      this.openNotification(message, count);
    }
  };


  hideNotificationPopup = () => {
    notification.close("notification-popup");
    notification.destroy();

    this.setState({
      notificationVisible: false,
      lastCount: 0,
      lastMessage: ""
    });

    useBoundStore.getState().setNotificationSeenUnseen({
      is_notification_cross_icon_clicked: true
    });
  };



  openNotification = (message, count) => {
    const isIPhone14PM =
      typeof window !== "undefined" && window.innerWidth <= 430;

    const fullWidthStyle = {
      position: "fixed",
      left: 0,
      right: 0,
      transform: "none",
      width: "100%",
    };

    notification.open({
      key: "notification-popup",
      message: `${count} New Notification${count > 1 ? "s" : ""}`,
      description: (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            notification.close("notification-popup");
            notification.destroy();
            useBoundStore
              .getState()
              .setNotificationSeenUnseen({
                unseen_notifications: 0,
                is_notification_cross_icon_clicked: false
              });
            this.setState({ toggle: true, lastCount: 0 });
          }}
        >
          {message}
        </a>
      ),
      duration: 0,
      style: isIPhone14PM ? fullWidthStyle : this.getNotificationStyle(),
      icon: (
        <Icon
          type="bell"
          style={{ fontSize: "26px", color: "rgb(255, 24, 24)" }}
        />
      ),
      onClose: () => this.setState(
        {
          notificationVisible: false,
          is_notification_cross_icon_clicked: true
        }, () => {
          useBoundStore.getState().setNotificationSeenUnseen({ is_notification_cross_icon_clicked: true });
          this.getNotificationStyle();
        }
      ),
    });
  };



  toggleController = () => {
    useBoundStore.getState().setNotificationSeenUnseen({
      unseen_notifications: 0,
      is_notification_cross_icon_clicked: false
    });
    this.setState((prevState) => ({
      toggle: !prevState.toggle,
      unseen_notifications: 0,
    }));
  };

  deleteNotification = (id) => {
    this.setState({ loading: true, toggleDialog: true, notificationId: id });
  };

  handleOk = () => {
    axios
      .post("/api/notification_delete", { notification_id: this.state.notificationId })
      .then((res) => {
        // console.log("✅ Notification deleted", res.data);
        this.toggleController();
        this.setState({ toggleDialog: false });
      });
  };

  handleCancel = () => {
    this.setState({ toggleDialog: false, loading: false });
  };

  disconnectSocket = () => {
    if (this.state.socket) {
      this.state.socket.emit("manual_disconnect", { userId: this.state.userId || null });
      this.state.socket.disconnect();
      console.log("Disconnected from WebSocket server on logout");
    }
  };

  render() {
    return (
      <div className="dropdown">
        {this.state.toggleDialog && (
          <Modal title="Alert" visible={this.state.toggleDialog} onOk={this.handleOk} onCancel={this.handleCancel}>
            <p>Are you sure you want to delete this notification?</p>
          </Modal>
        )}

        <button className="dropdownbtn" onClick={this.toggleController}>
          <div style={this.state.unseen_notifications ? {} : { display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Badge count={this.state.unseen_notifications || 0} offset={[15, 0]}>
              <button
                onClick={() => this.setState({ visibleNotification: true, notificationVisible: true })}
                style={{ background: "none", border: "none" }}
                aria-label="Notifications"
              >
                <img src={require("../assets/icons/menu/notification.png")} width={15} height={16} alt="Notifications" />
              </button>
            </Badge>
          </div>
        </button>

        {this.state.toggle && (
          <NotificationScroll
            deleteNotification={this.deleteNotification}
            history={this.props.history}
            toggleNotification={this.toggleController}
            hideNotificationPopup={this.hideNotificationPopup}
          />
        )}
      </div>
    );
  }
}

export default NotificationBell;



// WEBPACK FOOTER //
// ./src/components/notificationbell.js